
export const environment = {
  production: false, // or true
  firebase: {
    apiKey: 'AIzaSyCMiZEc4MfZqER7I_HfdQqI3wis0BA1pio',
    authDomain: 'spicetrail-7ad60.firebaseapp.com',
    projectId: 'spicetrail-7ad60',
    storageBucket: 'spicetrail-7ad60.firebasestorage.app',
    messagingSenderId: '836757599269',
    appId: '836757599269'
  }
};